import { useRouteError, useNavigate } from 'react-router-dom'
import { AuthRequiredError, ForbiddenError } from '@/lib/apiFetch'
import { pageLinks } from '../pageLinks'
import { useEffect } from 'react'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    if (error instanceof AuthRequiredError) {
      void navigate(pageLinks.global_shortcut_login())
      return
    }
    console.error('RouteErrorBoundary', error)
  }, [navigate, error])

  if (error instanceof AuthRequiredError) {
    return null
  }

  const ErrorContainer = ({ title, message, status }: { title: string; message: string; status?: string | number }) => (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center space-y-8">
        {status && (
          <div className="text-6xl text-neutral-200 select-none">
            {status}
          </div>
        )}
        <div className="space-y-2">
          <h1 className="text-lg text-neutral-900">{title}</h1>
          <p className="text-sm text-neutral-500">{message}</p>
        </div>
        <div className="h-px w-12 bg-neutral-200 mx-auto" />
        <a
          href={pageLinks.global_shortcut_home()}
          className="inline-block text-sm text-neutral-500 hover:text-neutral-900 underline"
        >
          Back to home
        </a>
      </div>
    </div>
  )

  if (error instanceof ForbiddenError) {
    return (
      <ErrorContainer
        title="Access Denied"
        message="You don't have permission to view this page."
        status={403}
      />
    )
  }

  return (
    <ErrorContainer
      title="Unexpected Error"
      message="An unexpected error occurred. Please try again later."
    />
  )
}
